
import { useMemo } from "react";
import { useSERPState } from "~/core/state/SERPStateContext"
import { QuerySetResults_State } from "~/core/state/types/state-results.schema";
import { QuerySet_State } from "~/core/state/types/state-sets.type";
import SRError from "~/utils/errors/srError";

export type TabResult = {
    title: string,
    result: QuerySetResults_State,
    setState: QuerySet_State
}

export type IUseTabResults = {
    results: TabResult[];
}

export const useTabsResults = (): IUseTabResults => {
    const state = useSERPState();

    const results = useMemo(() => {
        return state.results.sets
            .reduce((acc, set) => {
                const setState = state.sets.find((setC) => setC.querySet.identifier === set.querySetIdentifier);

                if (!setState) {
                    throw new SRError(`Could not find state for identifier ${set.querySetIdentifier}`);
                }

                return [...acc, {
                    title: setState.querySet.name,
                    setState: setState,
                    result: set
                }]
            }, [] as TabResult[])
    }, [state]);

    return {results};
}
